import React from 'react'
import PropTypes from 'prop-types'
import { Translate } from 'i18n'
import './style.css'


const AppFooter = props => (
    <footer className='app-footer'>
        { props.isVisible &&
            <div className='app-footer__content'>
                <div className='content-aligner'>
                    { props.children }
                </div>
            </div>
        }

        <div className='app-footer__copyright'>
            <div className='powered-by'>
                <Translate value='poweredBy' />

                <a href='https://outofmilk.com/'
                   target='_blank'
                   rel='noopener noreferrer'>
                    <span className='icon icon-oom-logo' />
                </a>
            </div>
        </div>
    </footer>
)

AppFooter.propTypes = {
    isVisible: PropTypes.bool.isRequired
}

export default AppFooter
